import React, { createContext, useState, useEffect, useContext } from 'react';
import settings from '../settings.js';

const AuthenticationContext = createContext();

const AuthenticationProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const url = settings.getUrl();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${url}/auth/user`, {
          method: 'GET',
          credentials: 'include',
        });
        const data = await response.json();
        if (data.user) {
          setUser(data.user);
        }
      } catch (error) {
        console.error('Failed to fetch user', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [url]);

  const logout = async () => {
    setLoading(true);
    try {
      await fetch(`${url}/auth/logout`, {
        method: 'GET',
        credentials: 'include',
      });
      setUser(null);
    } catch (error) {
      console.error('Logout error', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthenticationContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthenticationContext.Provider>
  );
};

const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error('useAuthentication must be used within an AuthenticationProvider');
  }
  return context;
};

export { AuthenticationContext, AuthenticationProvider, useAuthentication };
